import React, { useState } from 'react';
import { useHistory } from 'react-router-dom';
import { FaSearch } from 'react-icons/fa';
import { Form, Input, Button } from './style';
const Search = () => {
    const [ searchText, setSearchText ] = useState('');
    const history = useHistory();

    const handleSubmit = (e) => {
        e.preventDefault();
        if(searchText) {
            history.push(`/search?query=${searchText}`);
        }
    };

    return (
        <Form onSubmit={handleSubmit}>
            <Input placeholder="Search..." value={searchText} onChange={(e) => setSearchText(e.target.value.trim())} />
            <Button type="submit" aria-label="Search"><FaSearch /></Button>
        </Form>
    );
};

export default Search;